export { default, SIZES } from './Loading';
